import type { OracleInstaller } from "./types.ts";

export const loginInstaller: OracleInstaller["components"]["iam-write"]["items"]["login"] =
  {
    options: {
      iam: { items: {} },
    },
  };

/** Policy statements for the group that holds P0's service user */
const policyStatements = (group: string) => [
  `Allow group ${group} to manage users in tenancy`,
  `Allow group ${group} to manage groups in tenancy`,
  `Allow group ${group} to read domains in tenancy`,
  `Allow group ${group} to inspect compartments in tenancy`,
];

export const iamWriteInstructions: OracleInstaller["components"]["iam-write"]["instructions"] =
  () => {
    return {
      help: (
        <>
          P0 calls the Oracle Cloud API as a service user that you create for
          it, signing each call with that user&apos;s API key. P0 can manage
          groups in any identity domain in the tenancy.
        </>
      ),
      commands: {
        console: (
          <>
            <p>
              In the Oracle Cloud console, in your tenancy&apos;s Default
              identity domain:
            </p>
            <ol>
              <li>
                Create a user for P0, such as <code>p0-service</code>.
              </li>
              <li>
                Create a group, such as <code>p0-service-group</code>, and add
                the user to it.
              </li>
              <li>
                Create a policy in the root compartment with these statements:
                <pre>{policyStatements("p0-service-group").join("\n")}</pre>
              </li>
              <li>
                Open the user, add an API key, and download its private key.
                Keep the fingerprint that the console shows.
              </li>
            </ol>
            <p>
              Then click &quot;Next&quot; and enter the user&apos;s API key
              details.
            </p>
          </>
        ),
      },
    };
  };

export const oracleIamWriteInstaller: OracleInstaller["components"]["iam-write"] =
  {
    instructions: iamWriteInstructions,
    items: {
      login: loginInstaller,
    },
  };

export const oracleInstaller: OracleInstaller = {
  components: {
    "iam-write": oracleIamWriteInstaller,
  },
};
